import {
  ApiEndpoint,
  columnDirection,
  FormActionType,
  FormType,
  InputType,
  ServiceModalName,
  Translation,
} from '@enums';
import i18n from '@translations';
import type { EndpointType, FormConfig, FormConfigMapping, FormConfigMappingReturn } from '@types';

interface GetUserAgentFormConfigParams {
  endpoint?: EndpointType;
  value?: string[];
}

export const getIpBlacklistFormConfig = ({
  endpoint = ApiEndpoint.DEFAULT,
  value = [],
}: GetUserAgentFormConfigParams): FormConfig => {
  const USER_AGENT_FORM: FormConfigMapping = {
    [ApiEndpoint.DEFAULT]: {
      formType: FormType.CdnSecurity,
      formActionType: FormActionType.Save,
      endpoint: ApiEndpoint.DEFAULT,
      modalName: ServiceModalName.FormModal,
      label: {
        title: i18n.t(`${Translation.Configuration}:forms.security.configurationBlockUserIP`),
        description: i18n.t(`${Translation.Description}:configuration.security.configureBlockUserIP`),
        confirmButton: i18n.t(`${Translation.Common}:button.configure`),
      },
      inputList: [
        {
          name: 'ip_black_list',
          defaultValue: [],
          inputType: InputType.Area,
          isStringArray: true,
          placeholder: `8.8.8.8\n10.0.0.1\n192.168.1.1\n172.16.0.1`,
          label: i18n.t(`${Translation.Configuration}:forms.security.configurationBlockUserIP`),
          direction: columnDirection.Column,
          fullWidth: true,
          centerItem: true,
          withoutLabel: true,
          className: 'space-y-3',
          textInputClassName: 'min-h-40',
          value,
        },
      ],
    },
  };

  return USER_AGENT_FORM?.[endpoint as keyof FormConfigMappingReturn];
};
